import React from 'react';
import { FormControl, Select, MenuItem, makeStyles } from '@material-ui/core';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import positionChange from '../../commonFunction/positionChange';

const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
    '& div::before': {
      borderBottom: '1px solid transparent',
    },
    '& div::after': {
      borderBottom: '1px solid transparent',
    },
  },
  selectEmpty: {
    fontFamily: 'Roboto',
    fontSize: 13,
    lineHeight: 1.6,
    fontWeight: '700',
    '& div': {
      padding: '0 24px 0 0',
      marginTop: 1,
    },
  },
}));

function CustomBackSelect(props) {
  const classes = useStyles();
  const { initial, disabled = false } = props;
  const menusKeys = Object.keys(initial.obj.menus);

  return (
    <FormControl
      className={`${classes.formControl} ${classes.formControl2}`}
      disabled={disabled}
    >
      <Select
        value={initial.state}
        displayEmpty
        className={classes.selectEmpty}
        name={initial.name}
        inputProps={{ 'aria-label': 'Without label' }}
        onChange={(e) => {
          initial.change?.(e, initial);
        }}
        onBlur={(e) => {
          initial.set?.(e, initial);
        }}
        onOpen={positionChange}
      >
        {menusKeys.map((data) => (
          <MenuItem key={data} value={data}>
            {initial.obj.menus[data]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default React.memo(CustomBackSelect);
